import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// Main
import Login from '../src/components/utils/Login';
import ResetPassword from './components/hr/screens/ResetPassword';

// System Admin
import AdminDashboard from './components/admin/screens/AdminDashboard';
import AllCompanies from './components/admin/screens/AllCompanies';
import HRManagers from './components/admin/screens/HRManagers';
import Modules from './components/admin/screens/Modules';
import Packages from './components/admin/screens/Packages';
import CompanyDetails from './components/admin/screens/CompanyDetails';
import AdminHolidays from './components/admin/screens/AdminHolidays';
import TwoFactorAuthentication from './components/hr/screens/TwoFactorAuthentication';
import WebsiteAnalytics from './components/admin/screens/WebsiteAnalytics';
import InterestedCompanies from './components/admin/screens/InterestedCompanies';
import InterestedCandidates from './components/admin/screens/InterestedCandidates';
import Updates from './components/admin/screens/Updates';
import Subscribers from './components/admin/screens/Subscribers';
import Testimonials from './components/admin/screens/Testimonials';
import Verify2Factor from './components/utils/Verify2Factor';

// HR
import HRDashboard from '../src/components/hr/screens/HRDashboard';
import Departments from './components/hr/screens/Departments';
import Notices from './components/hr/screens/notices/Notices';
import CreateNotice from './components/hr/screens/notices/CreateNotice';
import EditNotice from './components/hr/screens/notices/EditNotice';
import Holidays from './components/hr/screens/notices/Holidays';
import AllEmployees from './components/hr/screens/AllEmployees';
import ExEmployees from './components/hr/screens/ExEmployees';
import CreateEmployee from './components/hr/screens/CreateEmployee';
import EmployeeDetails from './components/hr/screens/EmployeeDetails';
import EditEmployee from './components/hr/screens/EditEmployee';
import RunPayroll from './components/hr/screens/payroll/RunPayroll';
import PayrollHistory from './components/hr/screens/payroll/PayrollHistory';
import Reports from './components/hr/screens/payroll/Reports';
import LeaveHistory from './components/hr/screens/payroll/LeaveHistory';
import EmployeePayrollReview from './components/hr/screens/payroll/EmployeePayrollReview';
import Payslips from './components/hr/screens/payroll/Payslips';
import PayslipDetail from './components/hr/screens/payroll/PayslipDetail';
import HRChangePassword from './components/hr/screens/HRChangePassword';
import ExchangeRate from './components/hr/screens/payroll/ExchangeRate';

// Employee
import EmployeeDashboard from './components/employee/screens/EmployeeDashboard';
import PayrollApplyLeave from './components/employee/screens/PayrollApplyLeave';
import PayrollLeaveHistory from './components/employee/screens/PayrollLeaveHistory';
import MyPayslips from './components/employee/screens/MyPayslips';
import EmployeeChangePassword from './components/employee/screens/EmployeeChangePassword';
import EmployeeNotices from './components/employee/screens/EmployeeNotices';
import EmployeeLeaveHistory from './components/employee/screens/EmployeeLeaveHistory';
import ApplyLeave from './components/employee/screens/ApplyLeave';

// Manager
import ImmediateManagerDashboard from './components/immediate_manager/screens/ImmediateManagerDashboard';
import ManagerNotices from './components/immediate_manager/screens/ManagerNotices';
import PayrollLeaveRequests from './components/immediate_manager/screens/payroll/PayrollLeaveRequests';
import ManagerChangePassword from './components/immediate_manager/screens/ManagerChangePassword';
import ManagerPayrollLeaveHistory from './components/immediate_manager/screens/payroll/ManagerPayrollLeaveHistory';
import ManagerPayrollApplyLeave from './components/immediate_manager/screens/payroll/ManagerPayrollApplyLeave';
import ManagerLeaveHistory from './components/immediate_manager/screens/leave/ManagerLeaveHistory';
import ManagerApplyLeave from './components/immediate_manager/screens/leave/ManagerApplyLeave';
import LeaveRequests from './components/immediate_manager/screens/leave/LeaveRequests';
import InstallPWA from './components/common/InstallPWA';
import AllLeaveRequests from './components/hr/screens/leave/AllLeaveRequests';
import ManagerLeaveRequests from './components/hr/screens/leave/ManagerLeaveRequests';
import Professionals from './components/hr/screens/recruitment/Professionals';
import ProfessionalDetails from './components/hr/screens/recruitment/ProfessionalDetails';

function App() {
  return (
    <Router>
      <InstallPWA />
      <Routes>
        {/* Main */}
        <Route path="/" element={<Login />} />
        <Route path="/verify-2factor" element={<Verify2Factor />} />
        <Route path="/reset-password" element={<ResetPassword />} />.

        {/* System Admin */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/all-companies" element={<AllCompanies />} />
        <Route path="/admin/hr-managers" element={<HRManagers />} />
        <Route path="/admin/modules" element={<Modules />} />
        <Route path="/admin/packages" element={<Packages />} />
        <Route path="/admin/company-details/:companyId" element={<CompanyDetails />} />
        <Route path="/admin/holidays" element={<AdminHolidays />} />
        <Route path="/admin/website-analytics" element={<WebsiteAnalytics />} />
        <Route path='/admin/interested-companies' element={<InterestedCompanies/>} />
        <Route path='/admin/interested-candidates' element={<InterestedCandidates/>} />
        <Route path='/admin/updates' element={<Updates/>} />
        <Route path='/admin/subscribers' element={<Subscribers/>} />
        <Route path='/admin/testimonials' element={<Testimonials/>} />

        {/* HR */}
        <Route path="/hr-manager/dashboard" element={<HRDashboard />} />
        <Route path='/hr/departments' element={<Departments />} />
        <Route path='/hr/create-employee' element={<CreateEmployee />} />
        <Route path='/hr/all-employees' element={<AllEmployees />} />
        <Route path='/hr/employee/:id' element={<EmployeeDetails />} />
        <Route path='/hr/edit-employee/:id' element={<EditEmployee />} />
        <Route path='/hr/ex-employees' element={<ExEmployees />} />
        <Route path='/hr/payroll/run' element={<RunPayroll />} />
        <Route path='/hr/payroll/history' element={<PayrollHistory />} />
        <Route path='/hr/payroll/:id/payslips' element={<Payslips />} />
        <Route path='/hr/payroll/payslip-detail/:id' element={<PayslipDetail />} />
        <Route path='/hr/payroll/reports' element={<Reports />} />
        <Route path='/hr/payroll/leave-history' element={<LeaveHistory />} />
        <Route path='/hr/employee/:id/payroll-review' element={<EmployeePayrollReview />} />
        <Route path='/hr/change-password' element={<HRChangePassword />} />
        <Route path='/hr/two-factor-authentication' element={<TwoFactorAuthentication />} />
        <Route path='/hr/exchange-rate' element={<ExchangeRate />} />
        <Route path='/hr/leave/history' element={<AllLeaveRequests/>} />
        <Route path='/hr/leave/manager-requests' element={<ManagerLeaveRequests/>} />
        <Route path='/hr/recruitment/professionals' element={<Professionals/>} />
        <Route path='/hr/recruitment/professional/:id' element={<ProfessionalDetails/>} />

        {/* HR Notices */}
        <Route path="/hr/create-notice" element={<CreateNotice />} />
        <Route path="/hr/edit-notice/:id" element={<EditNotice />} />
        <Route path="/hr/notices" element={<Notices />} />
        <Route path="/hr/holidays" element={<Holidays />} />

        {/* Employee */}
        <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
        <Route path="/employee/apply-payroll-leave" element={<PayrollApplyLeave />} />
        <Route path="/employee/payroll-leave-history" element={<PayrollLeaveHistory />} />
        <Route path="/employee/payslips" element={<MyPayslips />} />
        <Route path="/employee/change-password" element={<EmployeeChangePassword />} />
        <Route path="/employee/notices" element={<EmployeeNotices />} />
        <Route path="/employee/leave-history" element={<EmployeeLeaveHistory />} />
        <Route path="/employee/apply-leave" element={<ApplyLeave />} />

        {/* Immediate Manager */}
        <Route path="/manager/dashboard" element={<ImmediateManagerDashboard />} />
        <Route path="/manager/notices" element={<ManagerNotices />} />
        <Route path="/manager/payroll/leave-requests" element={<PayrollLeaveRequests />} />
        <Route path="/manager/change-password" element={<ManagerChangePassword />} />
        <Route path="/manager/payroll/leave-history" element={<ManagerPayrollLeaveHistory />} />
        <Route path="/manager/payroll/apply-leave" element={<ManagerPayrollApplyLeave />} />
        <Route path="/manager/leave-requests" element={<LeaveRequests />} />
        <Route path="/manager/leave-history" element={<ManagerLeaveHistory />} />
        <Route path="/manager/apply-leave" element={<ManagerApplyLeave />} />





      </Routes>
    </Router>
  );
}

export default App;
